import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function MachineImage() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [machineList, setMachineList] = useState([]);
    const [formData, setFormData] = useState({
        machine: "", image: null, is_primary: false, addedby: userName, ip_add: ipAddress,
    });
    useEffect(() => {
        getMachine();
        getMachineImage();
    }, []);
    const getMachine = () => {
        axios
            .get(baseUrl + "machine/")
            .then((res) => {
                setMachineList(res.data);
            });
    };
    const getMachineImage = () => {
        setLoading(true);
        axios
            .get(baseUrl + "machine-image/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Machine Images.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value, type, checked, files} = e.target;
        if (type === "checkbox") {
            setFormData({
                ...formData, [name]: checked,
            });
        } else if (type === "file") {
            setFormData({
                ...formData, [name]: files[0],
            });
        } else {
            setFormData({
                ...formData, [name]: value,
            });
        }
    };
    const clearForm = () => {
        setFormData({
            machine: "", image: null, is_primary: false, addedby: userName, ip_add: ipAddress,
        });
    };
    const saveMachineImage = () => {
        const data = new FormData();
        data.append("machine", formData.machine);
        if (formData.image) {
            data.append("image", formData.image);
        }
        data.append("is_primary", formData.is_primary);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "machine-image/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Success", text: "Machine Image saved successfully.",
                });
                clearForm();
                getMachineImage();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Machine Image.",
                });
            });
    };
    const deleteMachineImage = (id) => {
        Swal.fire({
            title: "Delete Machine Image?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(`machine-image/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Machine Image deleted successfully.",
                        });
                        getMachineImage();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Machine Image.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {

        field: "machine_name", headerName: "Machine",
        renderCell: (params) => params.row.machine.machine_name || ""
    }, {
        field: "image", headerName: "Image", width: 220, renderCell: (params) => (<img
            src={params.value}
            alt=""
            style={{
                width: 160, height: 160, objectFit: "cover", borderRadius: 4,
            }}
        />),
    }, {
        field: "is_primary", headerName: "Primary", width: 100, renderCell: (params) => params.value ? "Yes" : "No",
    },];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Machine Image
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">

                            <label>Machine</label>

                            <select
                                className="form-select"
                                name="machine"
                                value={formData.machine}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Machine
                                </option>

                                {machineList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.machine_name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>Machine Image</label>

                            <input
                                type="file"
                                className="form-control"
                                name="image"
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-12 mb-3">

                            <div className="form-check mt-2">

                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="is_primary"
                                    checked={formData.is_primary}
                                    onChange={handleChange}
                                />

                                <label className="form-check-label">
                                    Primary Image
                                </label>

                            </div>

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveMachineImage}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Machine Image List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}
                                    
                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
export default MachineImage;